import * as e from "../node_modules/react-leaflet-cluster/lib/assets/marker-icon-2x.png.js";
import { getAugmentedNamespace as r } from "./_commonjsHelpers.js";
const o = /* @__PURE__ */ r(e);
export {
  o as default
};
